import { en } from '../i18n/messages.js';

/**
 * Service mode enum - matches API server exactly.
 * Exported for library consumers to use in their type definitions.
 */
export enum ServiceMode {
  Normal = 'normal',
  Paused = 'paused',
  VoiceOffline = 'voice_offline',
}

/**
 * Parse a string value into a ServiceMode enum.
 * Throws error for invalid values (fail-fast approach).
 *
 * @throws {Error} If value is not a valid ServiceMode
 */
export function parseServiceMode(value: unknown): ServiceMode {
  if (value === ServiceMode.Normal) return ServiceMode.Normal;
  if (value === ServiceMode.Paused) return ServiceMode.Paused;
  if (value === ServiceMode.VoiceOffline) return ServiceMode.VoiceOffline;

  throw new Error(`Invalid service mode: ${JSON.stringify(value)}`);
}

/**
 * Client-side English labels for service modes (public API for consumers).
 * Derived from the i18n catalog so the English source is not duplicated;
 * the localized UI uses `translate()` directly.
 */
export const SERVICE_MODE_LABELS: Record<ServiceMode, string> = {
  [ServiceMode.Normal]: en.dealerActive,
  [ServiceMode.Paused]: en.dealerAway,
  [ServiceMode.VoiceOffline]: en.textOnly,
};
